<template>
	<div>
		<div class="main-filter">
			<el-form inline :model="formInline" class="demo-form-inline">
				<el-form-item label="会话编号：">
					<el-autocomplete
						v-model.trim="formInline.identifier"
						:fetch-suggestions="querySearchAsync"
						clearable
						placeholder="请输入内容"
						@select="handleSelect"
					></el-autocomplete>
				</el-form-item>
				<el-form-item label="状态：">
					<el-select v-model="formInline.enabled" placeholder="请选择">
						<el-option v-for="item in statusList" :key="item.id" :label="item.title" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="onSearch" icon="el-icon-search">搜索</el-button>
				</el-form-item>
			</el-form>
		</div>
		<div class="main-content">
			<div class="main-content-title">
				<p>共有 {{ total }} 条结果</p>
			</div>
			<Table
				:loading="loading"
				:table-data="tableData"
				:total="total"
				:table-head="tableHead"
				:current-page.sync="queryData.current"
				:page-size.sync="queryData.size"
				:operation-column-width="160"
				:is-show-selection="false"
				:showOperation="true"
				@change-page="getList"
				:tableHeight="tableHeight"
			>
				<template #operation="{ scope }">
					<el-button @click="modifyParkInfo(scope.row, true)" size="mini" :type="scope.row.enabled ? 'primary' : 'info'" v-if="scope.row.enabled">
						处理
					</el-button>
					<el-button @click="stopMessage(scope.row)" size="mini" type="warning" :disabled="!scope.row.enabled"> 关闭会话 </el-button>
					<el-button @click="modifyParkInfo(scope.row, false)" size="mini" type="primary" v-if="!scope.row.enabled"> 查看 </el-button>
				</template>
			</Table>
		</div>
		<createView ref="createView" @getList="getList"></createView>
	</div>
</template>

<script>
export default {
	name: 'imgTextService',
	components: {
		Table: () => import('@/components/Table/table'),
		createView: () => import('./newDialog.vue'),
	},
	data() {
		return {
			formInline: {
				identifier: '',
				enabled: null,
			},
			typeList: [],
			statusList: [
				{
					id: null,
					title: '全部',
				},
				{
					id: true,
					title: '开启',
				},
				{
					id: false,
					title: '关闭',
				},
			],
			tableHead: [
				{
					label: '会话编号',
					prop: 'identifier',
					formatter: (row) => {
						return row.identifier || '-';
					},
				},
				{
					label: '医师名称',
					prop: 'medicalWorker',
					formatter: (row) => {
						return row.medicalWorker?.title || '-';
					},
				},
				{
					label: '用户',
					prop: 'creator',
					formatter: (row) => {
						return row.creator?.title || '-';
					},
				},
				{
					label: '会话建立时间',
					prop: 'createTime',
					formatter: (row) => {
						return row.createTime || '-';
					},
				},
			],
			loading: false,
			queryData: {
				current: 1,
				size: 10,
			},
			total: 0,
			tableData: [],
			options: [],
			link: '',
		};
	},
	computed: {
		tableHeight() {
			return window.innerHeight - 300;
		},
	},
	mounted() {
		this.getList();
	},
	methods: {
		// 查询条件
		onSearch() {
			this.queryData.current = 1;
			this.getList(null);
		},
		handleSelect(subInput) {
			this.formInline.identifier = subInput.identifier;
		},
		// 搜索建议
		querySearchAsync(queryString, cb) {
			queryString ? this.getList('filter') : '';
			clearTimeout(this.timeout);
			this.timeout = setTimeout(() => {
				cb(this.options);
			}, 1000 * Math.random());
		},
		//获取列表
		getList(type = '') {
			type == 'filter' ? '' : (this.loading = true);
			let data = {
				...this.formInline,
				...this.queryData,
			};
			this.$http
				.get(this.api['PhotoInquiryController#index'].href, { params: data })
				.then((res) => {
					if (res.data && res.data.success) {
						if (type == 'filter') {
							this.options = res.data.collection.map((item) => {
								return {
									...item,
									value: item.identifier,
								};
							});
						} else {
							this.link = res.data._links?.create?.href || '';
							this.tableData = res.data.collection || [];
							this.total = res.data.pagination.totalItems || 0;
							this.loading = false;
						}
					}
				})
				.catch((e) => {
					this.loading = false;
				});
		},
		modifyParkInfo(row, state) {
			let data = {
				row,
				link: row._links.load.href,
				state,
			};
			this.$refs.createView.init(data);
		},
		showHistory() {},
		stopMessage(row) {
			this.$http
				.put(row._links.update.href, { enabled: false })
				.then((res) => {
					if (res.data && res.data.success) {
						this.$message.success('操作成功');
						this.getList();
					}
				})
				.catch((e) => {});
		},
	},
	created() {},
};
</script>

<style lang="scss" scoped>
.demo-form-inline {
	/deep/ .el-select {
		width: 120px !important;
		.el-input {
			width: 120px !important;
			.el-input__inner {
				width: 120px !important;
			}
		}
	}
	/deep/ .el-input {
		width: 160px;
	}
}
.main-content {
	&-title {
		line-height: 48px;
		display: flex;
		justify-content: space-between;
		/deep/ .el-button {
			padding: 0;
			width: 88px;
			text-align: center;
			margin-top: 8px;
			border-radius: 6px;
			height: 32px;
			line-height: 20px;
			span {
				display: inline-block;
				height: 14px;
			}
		}
	}
}
</style>